import React, { Component } from "react";

export default class TDate extends Component {
  componentWillReceiveProps(props) {}

  render() {
    const field = this.props.field;
    const i = this.props.id;
    return (
      <div className="form-group">
        <label htmlFor="formGroupExampleInput">
          <b>{field.label}</b>
        </label>
        <input
          type="date"
          className="form-control"
          id="formGroupExampleInput"
          key={i}
          name={field.name}
          disabled="disabled"
        />
      </div>
    );
  }
}

//            id={field.name}
